import { setDictionary, Dictionary } from '@travel/translation';

const initTranslation = (dictionary: Dictionary) => {
  setDictionary(dictionary);
};

export default initTranslation;
